import React from "react";
import { Form, Container, Row, Col, FloatingLabel, Button } from 'react-bootstrap';
import {Helmet} from "react-helmet";

const Contact = () => {
    // const [status, setStatus] = useState("Submit");
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setStatus("Sending...");
    //     const { name, email, message } = e.target.elements;
    //     let details = {
    //         name: name.value,
    //         email: email.value,
    //         message: message.value,
    //     };
    //     let response = await fetch("http://localhost:5000/contact", {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json;charset=utf-8",
    //         },
    //         body: JSON.stringify(details),
    //     });
    //     setStatus("Submit");
    //     let result = await response.json();
    //     // alert(result.status);
    // };
    window.scrollTo(0, 0);
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>vizfm - Contact Us</title>
                <link rel="canonical" href="https://www.vizfm.com/contact" />
                <meta name="description" content="Financial Market Visualization Contact us" />
            </Helmet>

            <Container fluid>
                <Row>
                    <Col></Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                        <h3>Contact Us</h3>
                        <h6>Email: support@vizfm.com</h6>
                        <FloatingLabel
                            controlId="floatingName"
                            label="Name"
                            className="mb-3"
                        >
                            <Form.Control placeholder="Enter your Name" />
                        </FloatingLabel>

                        <FloatingLabel
                            controlId="floatingPhone"
                            label="Phone Number"
                            className="mb-3"
                        >
                            <Form.Control type="phone" placeholder="Phone Number" />
                        </FloatingLabel>


                        <FloatingLabel
                            controlId="floatingEmail"
                            label="Email address"
                            className="mb-3"
                        >
                            <Form.Control type="email" placeholder="Enter your email id" />
                        </FloatingLabel>
                        <FloatingLabel controlId="floatingTextarea2" label="Message">
                            <Form.Control
                                as="textarea"
                                placeholder="Leave a comment here"
                                style={{ height: '200px' }}
                            />
                        </FloatingLabel>

                        <Form.Group as={Row} className="mb-3">
                            <p></p>
                            <Col>
                                <Button type="submit">Send Message</Button>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col></Col>
                </Row>
            </Container>
        </div>
    );
};

export default Contact;